export default __webpack_public_path__ + "df4ae8d26e98ed6fcbd5e73244055ed4.png";